import v from "./ghl-ui.es787.js";
import f from "./ghl-ui.es1222.js";
import a from "./ghl-ui.es1223.js";
import S from "./ghl-ui.es1221.js";
import { DragStartSensorEvent as w, DragMoveSensorEvent as T, DragStopSensorEvent as L } from "./ghl-ui.es346.js";
const u = Symbol("onTouchStart"), r = Symbol("onTouchEnd"), g = Symbol("onTouchMove"), l = Symbol("startDrag"), s = Symbol("onDistanceChange");
let d = !1;
window.addEventListener("touchmove", (c) => {
  d && c.preventDefault();
}, {
  passive: !1
});
class y extends S {
  constructor(t = [], e = {}) {
    super(t, e), this.currentScrollableParent = null, this.tapTimeout = null, this.touchMoved = !1, this.pageX = null, this.pageY = null, this[u] = this[u].bind(this), this[r] = this[r].bind(this), this[g] = this[g].bind(this), this[l] = this[l].bind(this), this[s] = this[s].bind(this);
  }
  attach() {
    document.addEventListener("touchstart", this[u]);
  }
  detach() {
    document.removeEventListener("touchstart", this[u]);
  }
  [u](t) {
    const e = v(t.target, this.containers);
    if (!e || this.options.handle && t.target && !v(t.target, this.options.handle))
      return;
    const n = v(t.target, this.options.draggable);
    if (!n)
      return;
    const {
      distance: i = 0
    } = this.options, {
      delay: o
    } = this, {
      pageX: h,
      pageY: m
    } = a(t);
    Object.assign(this, {
      pageX: h,
      pageY: m
    }), this.onTouchStartAt = Date.now(), this.startEvent = t, this.currentContainer = e, this.originalSource = n, document.addEventListener("touchend", this[r]), document.addEventListener("touchcancel", this[r]), document.addEventListener("touchmove", this[s]), e.addEventListener("contextmenu", p), i && (d = !0), this.tapTimeout = window.setTimeout(() => {
      this[s]({
        touches: [{
          pageX: this.pageX,
          pageY: this.pageY
        }]
      });
    }, o.touch);
  }
  [l]() {
    const t = this.startEvent, e = this.currentContainer, n = a(t), i = this.originalSource, o = new w({
      clientX: n.pageX,
      clientY: n.pageY,
      target: t.target,
      container: e,
      originalSource: i,
      originalEvent: t
    });
    this.trigger(this.currentContainer, o), this.dragging = !o.canceled(), this.dragging && document.addEventListener("touchmove", this[g]), d = this.dragging;
  }
  [s](t) {
    const {
      distance: e
    } = this.options, {
      startEvent: n,
      delay: i
    } = this, o = a(n), h = a(t), m = Date.now() - this.onTouchStartAt, E = f(o.pageX, o.pageY, h.pageX, h.pageY);
    Object.assign(this, h), clearTimeout(this.tapTimeout), m < i.touch ? document.removeEventListener("touchmove", this[s]) : E >= e && (document.removeEventListener("touchmove", this[s]), this[l]());
  }
  [g](t) {
    if (!this.dragging)
      return;
    const {
      pageX: e,
      pageY: n
    } = a(t), i = document.elementFromPoint(e - window.scrollX, n - window.scrollY), o = new T({
      clientX: e,
      clientY: n,
      target: i,
      container: this.currentContainer,
      originalEvent: t
    });
    this.trigger(this.currentContainer, o);
  }
  [r](t) {
    if (clearTimeout(this.tapTimeout), d = !1, document.removeEventListener("touchend", this[r]), document.removeEventListener("touchcancel", this[r]), document.removeEventListener("touchmove", this[s]), this.currentContainer && this.currentContainer.removeEventListener("contextmenu", p), !this.dragging)
      return;
    document.removeEventListener("touchmove", this[g]);
    const {
      pageX: e,
      pageY: n
    } = a(t), i = document.elementFromPoint(e - window.scrollX, n - window.scrollY);
    t.preventDefault();
    const o = new L({
      clientX: e,
      clientY: n,
      target: i,
      container: this.currentContainer,
      originalEvent: t
    });
    this.trigger(this.currentContainer, o), this.currentContainer = null, this.dragging = !1, this.startEvent = null;
  }
}
function p(c) {
  c.preventDefault(), c.stopPropagation();
}
export {
  y as default
};
